var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.98 5.43h-8.53v-1.3A4.14 4.14 0 0 0 19.3 0h-3.62a4.14 4.14 0 0 0-4.14 4.14v1.3H3.02A2.33 2.33 0 0 0 .69 7.75v19.91A2.33 2.33 0 0 0 3.02 30h28.96a2.33 2.33 0 0 0 2.33-2.33V7.76a2.33 2.33 0 0 0-2.33-2.33Zm-17.58 0v-1.3c0-.7.58-1.28 1.29-1.28h3.62c.71 0 1.3.58 1.3 1.29v1.3H14.4Zm1.17 11.76v-2.5h3.86v2.5h-3.86Zm-12.03-.36a5 5 0 0 0 2.2.5h7.68a2.33 2.33 0 0 0 2.27 1.8h3.62c1.1 0 2.03-.77 2.27-1.8h7.69a5 5 0 0 0 2.2-.5v9.94a.4.4 0 0 1-.4.38H3.93a.39.39 0 0 1-.38-.38v-9.94Zm25.73-2.35h-7.69a2.33 2.33 0 0 0-2.27-1.8h-3.62c-1.1 0-2.03.77-2.27 1.8H5.73a2.2 2.2 0 0 1-2.2-2.2V8.66c0-.2.18-.38.4-.38h27.15c.21 0 .38.17.38.38v3.62a2.2 2.2 0 0 1-2.2 2.2Z"
  })));
};
export default SvgBriefcase;